module.exports = __webpack_public_path__ + "static/Vazir-Bold-b14156014932840c3eca2b22ed09762c.woff2";